export const originPath = window.location.origin

export const MAX_UPLOAD_FILE_SIZE = 1024 * 1024 * 5 // 5 MB
